import { router, setPageContent } from "..";
import { putPassword } from "../api/password";
import { sendVerificationCode } from "../api/send-verification-code";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { Bulma } from "../view/bulma";
import { centeredBox, passwordInput } from "../view/components";

function resetPasswordPage() {
	const email = Bulma.input({
		type: "email",
	});

	const verificationCode = Bulma.input({
		type: "text",
	});

	const password = passwordInput();

	function onClickSendVerificationCode() {
		const attempt = errorSection.attempt(async () =>
			sendVerificationCode(email.getValue()),
		);
		loadingScreen.waitFor(attempt);
	}

	function onClickSave() {
		const attempt = errorSection.attempt(async () => {
			await putPassword(
				email.getValue(),
				password.getValue(),
				verificationCode.getValue(),
			);
			router.jump("/sign-in");
		});
		loadingScreen.waitFor(attempt);
	}

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(t.resetPassword),
			document.createElement("hr"),
			Bulma.title(t.passwordResetStep1, "is-6"),
			Bulma.field(
				{},
				Bulma.label(t.email),
				Bulma.control({}, email.element),
			),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickSendVerificationCode,
						styles: ["is-primary"],
					},
					t.sendVerificationCode,
				),
			),
			document.createElement("hr"),

			Bulma.title(t.passwordResetStep2, "is-6"),
			Bulma.field(
				{},
				Bulma.label(t.verificationCode),
				Bulma.control({}, verificationCode.element),
			),
			Bulma.field({}, Bulma.label(t.password), password.element),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickSave,
						styles: ["is-primary"],
					},
					t.save,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/sign-in"),
						styles: ["is-primary"],
					},
					t.cancel,
				),
			),
		),
	);
}

export { resetPasswordPage };
